import { styled } from '@material-ui/core'

export const Instruction = styled('ul')(({ theme }) => ({
  boxSizing: 'border-box',
  marginLeft: theme.spacing(2),
  listStyleType: 'decimal',
}))

export const InstructionItem = styled('li')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: 16,
  lineHeight: '24px',
}))
